module.exports = __webpack_public_path__ + "img/sieckFinesseSequence1.8a40c38d.png";